import { HostListener, Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Routes, RouterModule, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions } from '../../common/customfunctions';
import * as Highcharts from 'highcharts'
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'app-prd-mgr',
  templateUrl: './prd-mgr.component.html',
  styleUrls: ['./prd-mgr.component.css']
})
/** prd-mgr component*/
export class PrdMgrComponent {
  DueArticleList;
  /** prd-mgr ctor */
  constructor(private router: Router, http: HttpClient) {
    this.LoadChartData(null, null, null);
  }
  @HostListener('window:beforeunload') goToPage() {
    this.router.navigate(['/prd-mgr']);
  }
  ngOnInit(): void {
    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');
    this.GetDashboardDetails();
  }

  GetDashboardDetails(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val()
    };
    ApiMethod.postMethod('dash/summary_pm', postData).subscribe(
      resonse => {
        this.DueArticleList = resonse.aDueitemList;
        let DeliveryItem = resonse.aDeliveryitemList;
        let SummaryList = resonse.aSummaryitemList;

        let chartData: any = [];
        chartData.push({ y: DeliveryItem[0]["FirstProof"], name: "FirstProof" });
        chartData.push({ y: DeliveryItem[0]["Correction"], name: "Correction" });
        chartData.push({ y: DeliveryItem[0]["OnlinePreview"], name: "Online" });
        chartData.push({ y: DeliveryItem[0]["Revises"], name: "Revises" });
        chartData.push({ y: DeliveryItem[0]["Printer"], name: "Printer" });
        chartData.push({ y: DeliveryItem[0]["FinalWeb"], name: "FinalWeb" });

        let chartDataCol: any = []; let chartDataCol1: any = [];
        $(SummaryList).each(function (index, val) {
          chartDataCol.push({ y: val.Ingestions, name: val.CurrentMonth });
          chartDataCol1.push({ y: val.Delivery, name: val.CurrentMonth });
        });

        this.LoadChartData(chartData, chartDataCol, chartDataCol1);
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );

  }

  highchartsPie: typeof Highcharts = Highcharts; chartOptions;
  highchartsCol: typeof Highcharts = Highcharts; chartOptionsCol;

  LoadChartData(chartData, chartDataCol, chartDataCol1): void {
    try {
      //Pie Chart
      this.highchartsPie = Highcharts;
      this.chartOptions = {
        chart: {
          plotBorderWidth: null,
          plotShadow: false
        },
        title: {
          text: 'Delivery Report'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}',
              style: {
                color: (Highcharts.theme) ||
                  'black'
              }
            }
          }
        },
        series: [{
          type: 'pie',
          name: "count",
          data: chartData
        }]
      };

      //Column Chart
      this.highchartsCol = Highcharts;
      this.chartOptionsCol = {
        chart: {
          type: 'column',
        },
        title: {
          text: 'Ingestion & Delivery'
        },
        xAxis: {
          categories: GlobalConstants.month_names,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: 'Ingestions',
            data: chartDataCol,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          },
          {
            name: 'Delivery',
            data: chartDataCol1,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          }
        ],

      };
    } catch (e) {
      $("#LoadingImage").hide();
      ngswal(e);
    }
  }
}
